var _learnq = _learnq || [];
function addedToCart() {
  fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      var cart = {
        total_price: data.total_price / 100,
        $value: data.total_price / 100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price / 100,
        items: data.items
      }
      if (typeof item !== 'undefined') {
        cart = Object.assign(cart, item)
      }
      _learnq.push(['track', 'Added to Cart', cart])
    }))
}
(function (ns, fetch) {
  ns.fetch = function () {
    // Resolve the request URL from the fetch arguments. We deliberately use the
    // request URL (always known) rather than Response.url, which is empty for
    // opaque cross-origin responses (no-cors beacons from analytics pixels) and
    // would otherwise match the original buggy substring check on every beacon.
    var requestUrl = '';
    if (arguments.length > 0) {
      var first = arguments[0];
      if (typeof first === 'string') {
        requestUrl = first;
      } else if (first && typeof first.url === 'string') {
        requestUrl = first.url;
      }
    }
    var response = fetch.apply(this, arguments);
    if (requestUrl && requestUrl.indexOf('/cart/add.js') !== -1) {
      response.then(function (res) {
        if (res && res.ok) {
          addedToCart();
        }
      }).catch(function () {});
    }
    return response;
  }
}(window, window.fetch))
